import styles from "./Staff.module.scss";
import MainTitle from "../../components/ui/MainTitle/MainTitle";
import { useTranslation } from "react-i18next";
import SearchInput from "../../components/SearchInput/SearchInput";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import StaffPopup from "./StaffPopup/StaffPopup";

const Staff = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");

  const [showCreatePopup, setShowCreatePopup] = useState<{
    show: boolean;
    activeTab: "admin" | "support";
  }>({ show: false, activeTab: "admin" });

  useEffect(() => {
    if (location.pathname === "/staff") {
      navigate("/staff/admins");
    }
  }, [location]);

  const onClickAddNew = () => {
    if (location.pathname === "/staff/admins") {
      setShowCreatePopup({ show: true, activeTab: "admin" });
    } else {
      setShowCreatePopup({ show: true, activeTab: "support" });
    }
  };

  const clickOnReset = () => {
    const activeTab = location.pathname === "/staff/admins" ? "admin" : "support";
    navigate(`/staff/${activeTab}s?shouldUpdate=${true}&searchValue=`);
  };

  const onClickSearch = () => {
    const activeTab = location.pathname === "/staff/admins" ? "admin" : "support";
    navigate(`/staff/${activeTab}s?shouldUpdate=${true}&searchValue=${inputValue}`);
  };

  return (
    <div className={"page-content"}>
      <MainTitle text={t("Staff")} />
      <SearchInput
        addNewBtn={true}
        clickOnReset={clickOnReset}
        onClickAddNew={onClickAddNew}
        onClickSearch={onClickSearch}
        inputValue={inputValue}
        setInputValue={setInputValue}
      />
      <div className={styles.tabs}>
        <NavLink
          className={({ isActive }) => (isActive ? `${styles.link} ${styles.active}` : styles.link)}
          to={"/staff/admins"}
        >
          {t("Admins")}
        </NavLink>
        <NavLink
          className={({ isActive }) => (isActive ? `${styles.link} ${styles.active}` : styles.link)}
          to={"/staff/supports"}
        >
          {t("Supports")}
        </NavLink>
      </div>
      <Outlet />
      {showCreatePopup.show && (
        <StaffPopup
          activeTab={showCreatePopup.activeTab}
          staffItem={null}
          setShowCreatePopup={setShowCreatePopup}
        />
      )}
    </div>
  );
};

export default Staff;
